const Filters = {
  delivered: null,
  dispatched: null,
  sentForPrinting: null,
  status: 'Approved',
  postType: 'Digital',
  after: '',
  before: '',
  sort: '-updated_at',
  skip: 1,
  limit: 10,
};

export default {
  namespaced: true,
  state: {
    filters: { ...Filters },
    defaultFilters: null, // used to set filters back to original
  },
  getters: {},
  mutations: {
    SET_FILTERS(state, value) {
      state.filters = value;

      localStorage.setItem('post-filters', JSON.stringify(state.filters));
    },
    SET_FILTER_ITEM(state, item) {
      state.filters[item.name] = item.value;

      localStorage.setItem('post-filters', JSON.stringify(state.filters));
    },
    SET_DEFAULT_FILTERS(state, value) {
      state.defaultFilters = value;
    },
  },
  actions: {
    setFiltersToDefault({ state, commit }) {
      if (state.defaultFilters) {
        commit('SET_FILTERS', state.defaultFilters);
      }
    },
    setFiltersFromLocal({ commit }) {
      const filters = localStorage.getItem('post-filters');

      if (filters) {
        commit('SET_FILTERS', JSON.parse(filters));
        commit('SET_DEFAULT_FILTERS', JSON.parse(filters));
      }
    },
    clearFilters({ commit }) {
      localStorage.removeItem('post-filters');
      commit('SET_DEFAULT_FILTERS', null);
      commit('SET_FILTERS', { ...Filters });
    },
  },
};
